<p-progressBar *ngIf="isProgressbarVisible"
               [style]="styles"
               mode="indeterminate">
</p-progressBar>
